/**
 * Kayuri Retoques 70 · Página del carrito en móvil.
 * La barra fija compacta (total + Pagar, sections/main-cart.liquid) solo se ve mientras el
 * resumen completo no está en pantalla; cuando aparece su botón "Finalizar compra", se oculta.
 * Consulta los elementos en cada comprobación porque el carrito se vuelve a pintar (morph)
 * al cambiar cantidades.
 */
(() => {
  const MOBILE = window.matchMedia('(max-width: 749px)');
  let frame = 0;

  const update = () => {
    frame = 0;
    const bar = document.querySelector('[data-kh-cart-bar]');
    if (!bar) return;
    const checkout = document.querySelector('.cart-page #checkout');
    let hide = !MOBILE.matches || !checkout;
    if (!hide) {
      const rect = checkout.getBoundingClientRect();
      // Oculta cuando el botón del resumen ya está visible o se ha pasado de largo
      hide = rect.top < window.innerHeight - 8;
    }
    bar.classList.toggle('is-hidden', hide);
    document.documentElement.classList.toggle('kh-cart-bar-on', !hide);
  };

  const schedule = () => {
    if (!frame) frame = requestAnimationFrame(update);
  };

  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule);
  MOBILE.addEventListener('change', schedule);
  // Tras cambiar el carrito (el tema vuelve a pintar la sección)
  new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  schedule();
})();
